import React from 'react';
import { IMG } from './data';
const bonos = [{
  img: IMG.b1,
  tag: 'PARA EL BLOQUE COGNITIVO',
  title: 'Memoria Activa',
  desc: '30 actividades de memoria, atención, lenguaje, cálculo, orientación y recuerdos, más 5 sesiones cortas armadas y 10 láminas para imprimir.'
}, {
  img: IMG.b2,
  tag: 'PARA EL GRUPO',
  title: 'Juegos y dinámicas grupales',
  desc: '32 juegos para presentarse, moverse y reírse en grupo, y 6 talleres de 45 minutos listos para fechas especiales.'
}, {
  img: IMG.b3,
  tag: 'PARA VER EL AVANCE',
  title: 'Guía de evaluación inicial y final',
  desc: '5 pruebas simples para hacer en la semana 1 y en la 12, con planillas para anotar y comparar el avance de cada persona.'
}, {
  img: IMG.b4,
  tag: 'PARA ORGANIZARTE',
  title: 'Guía de seguimiento',
  desc: 'Ficha personal, asistencia de 12 semanas, registro por sesión, checklist de seguridad y mensajes listos para las familias.'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0b3a2d] py-16 px-4" data-id="element-1" data-mp="mx1y4zunad7e">
      <div className="max-w-5xl mx-auto" data-id="element-2" data-mp="29rbhexohv9z5">
        <div className="text-center mb-10" data-id="element-3" data-mp="29q8q4on9f5ip">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-4" data-mp="2eq4jzv28tgkj">🎁 4 BONOS DE REGALO</h2>
          <p className="text-[#F2C14E] font-bold text-lg" data-id="element-5" data-mp="2jixoqixpoowm">INCLUIDOS CON TU COMPRA</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10" data-id="element-6" data-mp="2oh9233n7thjl">
          {bonos.map((b, i) => <div key={b.title} className="bg-[#06291f] border border-[#F2C14E] rounded-2xl p-6 flex flex-col" data-id="element-7" data-mp="1qu0jphiigolt" data-mpi={i}>
              <div className="bg-white/5 rounded-xl flex justify-center py-5 mb-5" data-id="element-8" data-mp="1vtd2nr69hbj4">
                <img src={b.img} alt={'Bono ' + (i + 1) + ' · ' + b.title} loading="lazy" className={`w-[52%] aspect-[210/297] object-cover rounded-md shadow-2xl ${i % 2 ? 'rotate-2' : '-rotate-2'}`} data-id="element-9" data-mp="20r57fls08s4q" />
              </div>
              <div className="text-4xl font-black text-[#F2C14E] mb-1" data-id="element-10" data-mp="3c5s5p5vbl65c">0{i + 1}</div>
              <div className="text-[#9FE0C8] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-11" data-mp="3h4vaqqbavcdb">🎁 {b.tag}</div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-12" data-mp="1h23xvn775xdh">{b.title}</h3>
              <p className="text-gray-300 text-sm flex-1 mb-4" data-id="element-13" data-mp="1c53qn8ym2oks">{b.desc}</p>
              <span className="self-start bg-[#F2C14E] text-[#2a1d00] font-black text-sm px-3 py-1 rounded-full" data-id="element-14" data-mp="1q43cy9ynirds">GRATIS</span>
            </div>)}
        </div>
        <div className="border border-[#F2C14E]/40 rounded-2xl p-6 text-center bg-[#04201a]" data-id="element-15" data-mp="1m2zynrw953eo">
          <span className="text-[#F2C14E] text-xl sm:text-2xl font-black" data-id="element-16" data-mp="ydfg3a40g85x">Los 4 bonos → GRATIS con Agenda Activa</span>
        </div>
      </div>
    </section>;
}